import { useEffect, useState } from 'react'
import { Modal, InputNumber, Typography, message } from 'antd'
import { api } from '../api'

const { Text } = Typography

// Pregunta cuántos m² tiene la tahúlla de un pueblo que aún no está configurado.
// Sin este dato la app no puede pasar las hectáreas de SIGPAC a tahúllas.
export function PreguntaTahulla({ pueblo, onGuardado, onCancelar }) {
  const [m2, setM2] = useState(null)
  const [guardando, setGuardando] = useState(false)

  useEffect(() => { setM2(null) }, [pueblo])

  const guardar = async () => {
    if (!m2) { message.error('Escribe los metros cuadrados'); return }
    setGuardando(true)
    try {
      await api('/municipios', { method: 'POST', body: JSON.stringify({ municipio: pueblo.municipio, provincia: pueblo.provincia, tahulla_m2: m2 }) })
      message.success(`Tahúlla de ${pueblo.municipio} guardada`)
      onGuardado()
    } catch (err) {
      message.error(err.message)
    }
    setGuardando(false)
  }

  return (
    <Modal
      open={!!pueblo}
      title={pueblo ? `¿Cuánto mide la tahúlla en ${pueblo.municipio}?` : ''}
      okText="Guardar"
      cancelText="Ahora no"
      confirmLoading={guardando}
      onOk={guardar}
      onCancel={onCancelar}
    >
      <Text style={{ display: 'block', marginBottom: '12px' }}>
        Es la primera parcela de <strong>{pueblo?.municipio}</strong> ({pueblo?.provincia}). Para calcular sus tahúllas
        hace falta saber cuántos metros cuadrados tiene la tahúlla allí. Se usará para todas las parcelas de ese pueblo.
      </Text>
      <InputNumber
        autoFocus
        min={100}
        max={20000}
        value={m2}
        onChange={setM2}
        suffix="m²"
        placeholder="Ej.: 1185"
        style={{ width: '100%' }}
        onPressEnter={guardar}
      />
      <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginTop: '8px' }}>
        En la Vega Baja (Cox, Callosa...) suele ser 1.185 m²; en Murcia, 1.118 m². Se puede cambiar después en Configuración.
      </Text>
    </Modal>
  )
}
